




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Catalog {
    name: string;
}

@Component({ components: { SimpleText } })
export default class Name extends Vue {
    @Prop( { default: null }) public catalog !: Catalog;

    public static getNeededFields(): string[] {
        return [
            "catalog.name",
            "catalog.uuid"
        ];
    }
}
